import {createAction} from "@reduxjs/toolkit";
import {MeterFlowVolumeTotalSearchCriteria} from "@ots-frontend/ots-data";

export const setMeterFlowVolumeReviewPageFilter = createAction<MeterFlowVolumeTotalSearchCriteria>("ots-ui/meter-flow-volume-review-page/setFilter");
